import { FC } from "react";
import { Documents } from "~/components/client/documents";
import PageMeta from "~/components/common/meta";

type Props = {};

export const DocumentScreen: FC<Props> = () => {
  return (
    <>
      <PageMeta title={`Documents | Art Handler`} />
      <Documents />
    </>
  );
};
